<template>
    <b-popover
        :target="target"
        triggers="click focus"
        placement="vertical"
        v-if="!readonly"
        @shown="shown"
        @show="onShow"
    >
        <div class="row">
            <div class="col-12">

                <div class="paintpopover">

                    <div @click="saveAction(option.value)" class="paintpopover-item pointer mx-1" v-for="(option, index) in paintOptions" :key="index">
                        <div class="paintpopover-item-inner" :style="{background: option.color}">
                            <!--:class="{'badge-warning': value === option.value, 'badge-light': value !== option.value}"-->
                            {{option.value}}
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn-outline-secondary btn-sm" @click="saveAction(null)">
                            {{$t("Clear")}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </b-popover>
</template>

<script>
    export default {
        name: "PaintPopover",
        props: {target: String, save: Function, value: null, readonly: Boolean},
        components: {},
        data() {
            return {
                paintOptions: [
                    {value: 'A1', color: '#e1dcbf'},
                    {value: 'A2', color: '#d8ceaa'},
                    {value: 'A3', color: '#d6c99d'},
                    {value: 'A3.5', color: '#d2c08e'},
                    {value: 'A4', color: '#c3b27c'},
                    {value: 'B1', color: '#dedac1'},
                    {value: 'B2', color: '#ddd3b0'},
                    {value: 'B3', color: '#d6c89b'},
                    {value: 'B4', color: '#d3c390'},
                    {value: 'C1', color: '#d5cfaf'},
                    {value: 'C2', color: '#cfc29f'},
                    {value: 'C3', color: '#d1c4a1'},
                    {value: 'C4', color: '#bfaf7c'},
                    {value: 'D2', color: '#d3cdab'},
                    {value: 'D3', color: '#d1c4a1'},
                    {value: 'D4', color: '#d1c59d'},
                ]
            }
        },
        methods: {
            saveAction(value) {
                this.save(value);
                this.close()
            },

            close() {
                this.$root.$emit('bv::hide::popover');
            },

            onShow() {
                this.close();
            },

            shown() {
            }
        }
    }
</script>

<style scoped lang="scss">
    .popover {
        max-width: 310px;
    }
    .paintpopover {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        min-width: 300px;
        &-item {
            &-inner {
                display: flex;
                justify-content: center;
                align-items: flex-end;
                margin: 5px;
                height: 70px;
                width: 54px;
                font-size: 18px;
                color: #fff;
                transition: 1s linear;
                &:hover {
                    border: 2px solid #fff;
                }
            }
         }
    }
</style>
